<!--
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version: 
 * @Author: Wang
 * @Date: 2022-01-24 08:54:29
 * @LastEditors: ------
 * @LastEditTime: 2022-02-18 08:55:18
-->
<template>
  <div class="fangTan_container">
    <van-nav-bar
        title="我的意向单详情"
        @click-left="$router.push('/selfList')"
        left-arrow
        safe-area-inset-top
        placeholder
    />
    <div class="con">
      <div class="myInfo">
        <div class="info">
          <div class="title">
            <van-image width="0.5rem" height="0.5rem" :src="require('../../images/62.png')"></van-image>
            <span>意向单信息详情</span>
            <div class="box">
              <div class="box_item">
                <div class="contain">
                  姓名:{{ info.name || '暂无填写' }}
                </div>
                <div class="contain contains">
                  客户手机号:{{ info.mobile || "暂无填写" }}
                </div>
                <!-- <div class="contain">
                  用户性别：{{ info.sex_dictText || "暂无填写" }}
                </div> -->
                <!-- <div class="contain">
                  用户年龄：{{ info.age || "暂无填写" }}
                </div> -->
                <div class="contain contains">
                  所属销售:{{ info.salesName || "暂无填写" }}
                </div>
                <div class="contain contains">
                  需求服务类型:{{ info.nurseType_dictText || "暂无填写" }}
                </div>
                <div class="contain contains">
                  服务地址:{{ info.serviceDetailAddress || "暂无填写" }}
                </div>
                <div class="contain contains">
                  创建时间:{{ info.createTime || "暂无填写" }}
                </div>
                <div class="contain contains">
                  医保卡:{{ info.idCard || "暂无填写" }}
                </div>
                <div class="contain contains">
                  服务等级:{{ info.oldStatus || "暂无填写" }}
                </div>
                <div class="contain contains">
                  服务状态:{{ info.serviceStatus == 0 ? '已下站' : info.serviceStatus == 1 ? '中止' : info.serviceStatus == 2  ? '终止' : info.serviceStatus == 3 ? '申请中' : "暂无填写" }}
                </div>
                <div class="contain contains">
                  开发奖金发放状态:{{ info.isReward ==  0 ? "未发放" : "已发放" }}
                </div>
                <div class="contain contains">
                  待遇开始时间:{{ info.serverStartDate || "暂无填写" }}
                </div>
                <div class="contain contains">
                  待遇结束时间:{{ info.endDate || "暂无填写" }}
                </div>
                <div class="contain contains">
                  已服务工时:{{ info.settleHour || "暂无填写" }}
                </div>
                <div class="contain contains">
                  客户标签:{{ info.isNew == 0 ? '新客' : info.isNew == 1 ? '旧客' : "暂无填写" }}
                </div>
                <div class="contain contains">
                  开发奖金:{{ info.devReward || "暂无填写" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listNew } from "@/api/index";
export default {
    name: "",
    components: {},
    data() {
        return {
          info : {},
        };
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      const that = this;
      that.info = that.$route.query.res;
      console.log('that.info',that.info);
      // listNew({ id : that.info }).then((res) => {
      //   if (res.data.success) {
      //     that.data = res.data.result.records;
      //     console.log('that.data',that.data);
      //     that.data.forEach(element => {
      //       if(element.id == that.info.id){
      //         console.log(1);
      //       }
      //     });
      //   }
      // });
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    // 方法集合
    methods: {
      // initToken(id) {
      //   const that = this;
      //   listNew({ id : id }).then((res) => {
      //     if (res.data.success) {
      //       that.data = res.data.result.records;
      //       console.log('that.data',that.data);
      //       that.data.forEach(element => {
      //         if(element.id == that.info.id){
      //           console.log(1);
      //         }
      //       });
      //     }
      //   });
      // },
    },
};
</script>
<style lang="less" scoped>
html {
  // height: 100vh;
  background: #f0efef;
}

[v-cloak] {
  display: none !important;
}

.fangTan_container {
  background: #f0efef;
  width: 100%;
  height: 100vh;
}

/deep/ .van-nav-bar {
  background: #0dacf4;

  .van-nav-bar__title {
    color: #fff;
  }
}
// /deep/ .van-nav-bar {
//   background: var(--color);

//   .van-nav-bar__title {
//     color: #fff;
//   }
// }

/deep/ .van-nav-bar__left {
  .van-icon,
  .van-nav-bar__text {
    color: #fff;
  }
}

.con {
  background: #f0efef;
}

.myInfo {
  margin: 14px;

  .info {
    height: 200px;

    .title {
      height: 20px;
      line-height: 20px;

      span {
        margin-left: 6px;
        font-size: 16px;
        color: #333333;
      }

      .box {
        width: 347px;
        // height: 153px;
        background: #ffffff;
        border-radius: 6px;
        margin-top: 10px;

        .box_item {
          padding: 14px 0 14px 26px;
          width: 272px;
          // height: 118px;
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 300;
          color: #666666;
          line-height: 26px;

          .contains {
            word-break: keep-all;
            /* 不换行 */
            width: 272px;
            overflow-x: auto;
            white-space: nowrap;
            /* 不换行 */
          }
        }
      }
    }
  }

  .talk {
    margin-top: 14px;

    .titlt_talk {
      margin-left: 6px;
      font-size: 16px;
      color: #333333;
    }

    .talk_item {
      width: 347px;
      height: 104px;
      margin-top: 14px;
      background: #ffffff;
      border-radius: 14px 6px 6px 6px;

      .tip {
        width: 81px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        color: #fff;
        background: linear-gradient(0deg, #0ecde1 0%, #2bd79f 100%);
        border-radius: 14px 0px 14px 0px;
        font-size: 12px;
      }

      .serve_name {
        text-align: center;
        line-height: 52px;
        font-size: 14px;
        position: relative;

        .pay {
          text-align: left;
          margin-left: 12px;
          line-height: 4px;
          color: #666666;
        }

        .payBtn {
          position: absolute;
          right: 10px;
          top: -6px;

          button {
            width: 58px;
            height: 26px;
            margin-right: 10px;
          }
        }

        .icon {
          margin-left: 20px;
        }
      }
    }

    .none_talk {
      margin-top: 50px;

      .create_talk {
        width: 100%;
        text-align: center;

        button {
          width: 230px;
          background: linear-gradient(0deg, #6eaefc, #6875f1);
          font-size: 15px;
          border-radius: 21px;
          border: none;
        }
      }
    }
  }

  /deep/ .van-popup {
    width: 90%;
    height: 70%;
  }

  .popCell {
    padding: 20px 0;

    .p {
      font-size: 20px;
    }
  }
}

.over {
  /deep/ .van-overlay {
    background: rgba(0, 0, 0, 0.1);
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 304px;
    height: 386px;
    background-color: #fff;
  }

  .fontTip {
    line-height: 22px;
  }
}
</style>
